import LogOut from './LogOut'
Vue.component('LogOut', LogOut)



// WEBPACK FOOTER //
// ./src/js/components/LogOut/index.js